<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="table">
      <rest-list-column
        prop="title"
        :title="$t('EmailSavedRows__title')"
        :filterable="false"
        :filter-input="false"
        :sortable="false"
      />
      <rest-list-column-iframe
        prop="content"
        :title="$t('EmailSavedRows__content')"
      />
      <rest-list-column-actions v-if="!readonly">
        <template slot-scope="scope">
          <rest-list-action-update
            v-if="$can('EmailSavedRows::Update')"
            :route="rowUpdateRoute(scope.row)"
            title="EmailSavedRows_Action_Update"
          />
          <rest-list-action-delete
            :name="scope.row.title"
            v-if="$can('EmailSavedRows::Delete')"
            :endpoint="rowDeleteEndpoint(scope.row)"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPage'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnIFrame from '@/common/components/rest/RestListColumnIFrame'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'

export default {
  name: 'EmailSavedRowsListPage',

  components: {
    RestListActionDelete,
    RestListActionUpdate,
    RestListColumnActions,
    RestListColumn,
    RestListPage,
    'rest-list-column-iframe': RestListColumnIFrame
  },

  data() {
    return {
      types: {}
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'email-saved-rows',
        params: {}
      })
    },

    readonly() {
      return !this.$can('EmailSavedRows::Read')
    }
  },

  methods: {
    rowUpdateRoute(row) {
      return projectRoute({
        name: 'EmailSavedRowsUpdate',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `email-saved-rows/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/email-saved-rows/pages/EmailRowsSavedListPage.vue